export const HSE_URL = 'https://hse.nedgia.es'

export const seguimientoPuestaGasConfig = [['licencia', 'seguimiento_obras'], ['puesta_servicio']]

export const APP_EDITION_OPTIONS = {
  all: 'all',
  own: 'own',
  none: 'none',
}

export const GRID_ITEM_SMALL = {
  size: {
    xs: 12,
    sm: 6,
    md: 2,
  },
  sx: {
    padding: '12px',
  },
}
export const GRID_ITEM_MEDIUM = {
  size: {
    xs: 12,
    sm: 6,
    md: 3,
  },
  sx: {
    padding: '12px',
  },
}
export const GRID_ITEM_LARGE = {
  size: {
    xs: 12,
    sm: 12,
    md: 6,
  },
  sx: {
    padding: '12px',
  },
}
